
import Icon from '../../common/Icon'

export default {
  name: 'SiteFooter',
  components: { Icon },
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          exactListBlocked: ['/account/signin', '/account/signup', '/account/forgot', '/account/confirmed'],
          fragmentListBlocked: ['location', 'menu', 'order'],
          actions: [
            {
              name: 'Order Now',
              class: 'btn primary',
              iconName: '',
              iconClasses: '',
              callback: () => {},
            },
          ],
        }
      }
    }
  },
  computed: {
    showSiteOverlay() {
      if (!this.config) return true

      const exactBlock = this.config.exactListBlocked.find(page => page === this.$route.path)
      if (exactBlock) {
        return false
      }

      const fragmentBlock = this.config.fragmentListBlocked.find(page => this.$route.path.includes(page))
      if (fragmentBlock) {
        return false
      }

      return true
    },
  },
}
